export default {
  emptyFiltersErrorMessage: 'Please enter a value for all selected filters.',
  splashScreenMessages: {
    user: 'Fetching user information',
    orders: 'Hold tight! We are fetching your orders and saved views. '
  },
  customersColumnNames: {
    name: 'Name',
    companyName: 'Company Name',
    email: 'Email',
    city: 'City',
    state: 'State',
    country: 'Country'
  }
}
